import styled from 'styled-components';

// #region Styled Components
export const StyledTable = styled.table`
  border-collapse: collapse;
  text-align: left;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  font-size: 14px;
  color: ${props => props.theme.primaryTextColor};
  table-layout: ${props => props.fixed && 'inherit'};
  &::selection {
    text-shadow: 0;
    color: black;
  }
  ${(props) => {
    if (props.privateMode) {
      return `
        color: transparent;
        text-shadow: 0 0 25px rgba(0,0,0,0.25);
      `;
    }
    return '';
  }};

  @media print {
    font-size: 12px;
  }
`;
